import { useMemo, useState } from "react";
import VirtualizedTable from "../components/VirtualizeTable";
import ClassDelete from "./ClassDelete";
import { MRT_ColumnDef } from "material-react-table";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { useNavigate } from "react-router";

const ClassTableComponent = ({
  data,
  refetch,
}: {
  data: Array<{
    id: string;
    date?: Date;
    startTime?: Date;
    endTime?: Date;
    name: string;
    description?: string;
    fightsId: string;
    spacesId: string;
    dayWeek: string;
    checkinLock: boolean;
    automaticCompletion: boolean;
    professorId?: Array<string>;
    createdAt?: Date;
    status?: boolean;
    professors?: Array<{
      professorId: string;
      fullName: string;
    }>;
  }>;
  refetch: () => void;
}) => {
  const [deleteAlert, setDeleteAlert] = useState(false);

  const [id, setId] = useState("");
  const navigate = useNavigate();

  const columns = useMemo<MRT_ColumnDef<(typeof data)[0]>[]>(() => {
    return [
      {
        accessorKey: "name",
        header: "Nome",
      },
      {
        accessorKey: "description",
        header: "Descrição",
      },
      {
        accessorKey: "status",
        header: "Status",
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ cell }: any) => {
          const status = cell.getValue();
          const label = status ? "Ativo" : "Inativo";
          const color = status ? "#2e7d32" : "#d32f2f";
          return (
            <div
              style={{
                padding: "4px 12px",
                borderRadius: "12px",
                backgroundColor: color,
                color: "#fff",
                fontWeight: 600,
                fontSize: "0.75rem",
                textAlign: "center",
                display: "inline-block",
                minWidth: "100px",
              }}
            >
              {label}
            </div>
          );
        },
      },
      {
        id: "edit",
        header: "Editar",
        size: 50,
        Cell: ({ row }: any) => (
          <IconEdit
            onClick={() => {
              navigate("/class/" + row.original.id);
            }}
            style={{ cursor: "pointer", color: "#FFF" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
      {
        id: "delete",
        header: "Excluir",
        size: 50,
        Cell: ({ row }: any) => (
          <IconTrash
            onClick={() => {
              setId(row.original.id);
              setDeleteAlert(true);
            }}
            style={{ cursor: "pointer", color: "#d32f2f" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
    ];
  }, [data]);

  return (
    <>
      <VirtualizedTable
        data={data}
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />

      <ClassDelete
        open={deleteAlert}
        onClose={() => setDeleteAlert(false)}
        id={id}
        onAction={refetch}
      />
    </>
  );
};

export default ClassTableComponent;
